
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Home": () => {
return Promise.all(/*  | __federation_expose_Home */ [__webpack_require__.e("558"), __webpack_require__.e("849"), __webpack_require__.e("275"), __webpack_require__.e("214")]).then(() => (() => (__webpack_require__(981))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };